import React, { useState } from 'react';
import api from '../../config/axiosInstance';
import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';

const BulkUploadModal = ({ show, onHide, onSuccess }) => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    if (!show) return null;

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            showToast('error', 'Please select a CSV file first.', 'Error');
            return;
        }

        const formData = new FormData();
        formData.append('csv', file);

        setUploading(true);
        try {
            const res = await api.post('/product/bulk/create', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (res.status === 200 || res.status === 201) {
                showToast('success', res.data.message || 'Products uploaded successfully.', 'Success');
                setFile(null);
                onSuccess();
                onHide();
            }
        } catch (err) {
            handleErrors(err);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Bulk Product Upload</h5>
                        <button type="button" className="btn-close" onClick={onHide}></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Select CSV File</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    accept=".csv"
                                    onChange={handleFileChange}
                                    required
                                />
                                <div className="form-text mt-2">
                                    Please upload a CSV file with product details.
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger light" onClick={onHide} disabled={uploading}>
                                Close
                            </button>
                            <button type="submit" className="btn btn-primary" disabled={uploading}>
                                {uploading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Uploading...
                                    </>
                                ) : (
                                    'Submit'
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BulkUploadModal;
